import React, { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import About from "@/components/site/About";
import Campaigns from "@/components/site/Campaigns";
import NewsList from "@/components/site/NewsList";

import Leadership from "@/components/site/Leadership";
import Gallery from "@/components/site/Gallery";
import JoinSection from "@/components/site/JoinSection";

export default function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <main data-testid="home-page">
        <Hero />
        <Ticker />
        <About />
        <Campaigns />
        <NewsList />
        <Leadership />
        <Gallery />
        <JoinSection />
      </main>
      <Footer />
    </div>
  );
}
